import { Region } from 'core/geometry';

export namespace Aspect
{
  export enum Orientation
  {
    Portrait,
    Landscape,
  }

  export function getOrientation(region: Region): Orientation
  {
    return region.width >= region.height
        ? Orientation.Landscape
        : Orientation.Portrait;
  }

  export function getShortSide(orientation: Orientation, region: Region): number
  {
    return orientation === Orientation.Landscape ? region.height : region.width;
  }

  export function getLongSide(orientation: Orientation, region: Region): number
  {
    return orientation === Orientation.Landscape ? region.width : region.height;
  }

  export function getAspectRatio(
      orientation: Orientation, region: Region): number
  {
    return getLongSide(orientation, region) / getShortSide(orientation, region);
  }
} // namespace Aspect
